// js/custom-element/section/product/product-media.js
if (!customElements.get('product-media')) {
  var ProductMedia = class extends CustomHTMLElement {
    async connectedCallback() {
      this.mainCarousel = this.querySelector('flickity-carousel');
      if (this.hasAttribute('reveal-on-scroll')) {
        this._setupVisibility();
      }
      if (this.mainCarousel.childElementCount === 1) {
        return;
      }
      this.selectedVariantMediaId = null;
      this.viewInSpaceElement = this.querySelector('[data-shopify-model3d-id]');
      this.zoomButton = this.querySelector('.product__zoom-button');
      this.product = await ProductLoader.load(this.getAttribute('product-handle'));
      document.getElementById(this.getAttribute('form-id'))?.addEventListener('variant:changed', this._onVariantChanged.bind(this));
      this.mainCarousel.addEventListener('model:played', () => this.mainCarousel.setDraggable(false));
      this.mainCarousel.addEventListener('model:paused', () => this.mainCarousel.setDraggable(true));
      this.mainCarousel.addEventListener('video:played', () => this.mainCarousel.setDraggable(false));
      this.mainCarousel.addEventListener('video:paused', () => this.mainCarousel.setDraggable(true));
      this.mainCarousel.addEventListener('flickity:ready', this._onFlickityReady.bind(this));
      this.mainCarousel.addEventListener('flickity:slide-changed', this._onFlickityChanged.bind(this));
      this.mainCarousel.addEventListener('flickity:slide-settled', this._onFlickitySettled.bind(this));
      this._onFlickityReady();
    }
    get thumbnailsPosition() {
      return window.matchMedia(window.themeVariables.breakpoints.pocket).matches ? 'bottom' : this.getAttribute('thumbnails-position');
    }
    async _setupVisibility() {
      await this.untilVisible();
      const flickityInstance = await this.mainCarousel.flickityInstance,
        image = flickityInstance ? flickityInstance.selectedElement.querySelector('img') : this.querySelector('.product__media-image-wrapper img'),
        prefersReducedMotion = MediaFeatures.prefersReducedMotion();
      await imageLoaded(image);
      const animation = new CustomAnimation(
        new ParallelEffect([
          new CustomKeyframeEffect(image, { opacity: [0, 1], transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, 'scale(1)'] }, { duration: 500, easing: 'cubic-bezier(0.65, 0, 0.35, 1)' }),
          new ParallelEffect(
            Array.from(this.querySelectorAll('.product__thumbnail-item:not(.is-filtered)')).map((item, index) => {
              return new CustomKeyframeEffect(
                item,
                {
                  opacity: [0, 1],
                  transform: this.thumbnailsPosition === 'left' ? [`translateY(${prefersReducedMotion ? 0 : '40px'})`, 'translateY(0)'] : [`translateX(${prefersReducedMotion ? 0 : '50px'})`, 'translateX(0)'],
                },
                {
                  duration: 250,
                  delay: prefersReducedMotion ? 0 : 100 * index,
                  easing: 'cubic-bezier(0.75, 0, 0.175, 1)',
                }
              );
            })
          ),
        ])
      );
      this._hasSectionReloaded ? animation.finish() : animation.play();
    }
    async _onVariantChanged(event) {
      const variant = event.detail.variant;
      const filteredMediaIds = [];
      let shouldReload = false;
      this.product['media'].forEach((media) => {
        let matchMedia2 = variant['featured_media'] && media['id'] === variant['featured_media']['id'];
        if (media['alt']?.includes('#')) {
          shouldReload = true;
          if (!matchMedia2) {
            const altParts = media['alt'].split('#'),
              mediaGroupParts = altParts.pop().split('_');
            this.product['options'].forEach((option) => {
              if (option['name'].toLowerCase() === mediaGroupParts[0].toLowerCase()) {
                if (variant['options'][option['position'] - 1].toLowerCase() !== mediaGroupParts[1].trim().toLowerCase()) {
                  filteredMediaIds.push(media['id']);
                }
              }
            });
          }
        }
      });
      const currentlyFilteredIds = [...new Set(Array.from(this.querySelectorAll('.is-filtered[data-media-id]')).map((item) => parseInt(item.getAttribute('data-media-id'))))];
      if (currentlyFilteredIds.some((value) => !filteredMediaIds.includes(value))) {
        const selectedMediaId = variant['featured_media'] ? variant['featured_media']['id'] : this.product['media'].map((item) => item.id).filter((item) => !filteredMediaIds.includes(item))[0];
        Array.from(this.querySelectorAll('[data-media-id]')).forEach((item) => {
          item.classList.toggle('is-filtered', filteredMediaIds.includes(parseInt(item.getAttribute('data-media-id'))));
          item.classList.toggle('is-selected', selectedMediaId === parseInt(item.getAttribute('data-media-id')));
          item.classList.toggle('is-initial-selected', selectedMediaId === parseInt(item.getAttribute('data-media-id')));
        });
        this.mainCarousel.reload();
      } else {
        if (!event.detail.variant['featured_media'] || this.selectedVariantMediaId === event.detail.variant['featured_media']['id']) {
          return;
        }
        this.mainCarousel.select(`[data-media-id="${event.detail.variant['featured_media']['id']}"]`);
      }
      this.selectedVariantMediaId = event.detail.variant['featured_media'] ? event.detail.variant['featured_media']['id'] : null;
    }
    async _onFlickityReady() {
      const flickityInstance = await this.mainCarousel.flickityInstance;
      if (['video', 'external_video'].includes(flickityInstance.selectedElement.getAttribute('data-media-type')) && this.hasAttribute('autoplay-video')) {
        flickityInstance.selectedElement.firstElementChild.play();
      }
    }
    async _onFlickityChanged() {
      const flickityInstance = await this.mainCarousel.flickityInstance;
      flickityInstance.cells.forEach((item) => {
        if (['external_video', 'video', 'model'].includes(item.element.getAttribute('data-media-type'))) {
          item.element.firstElementChild.pause();
        }
      });
    }
    async _onFlickitySettled() {
      const flickityInstance = await this.mainCarousel.flickityInstance,
        selectedSlide = flickityInstance.selectedElement;
      if (this.zoomButton) {
        this.zoomButton.hidden = selectedSlide.getAttribute('data-media-type') !== 'image';
      }
      if (this.viewInSpaceElement) {
        this.viewInSpaceElement.setAttribute('data-shopify-model3d-id', this.viewInSpaceElement.getAttribute('data-shopify-model3d-default-id'));
      }
      switch (selectedSlide.getAttribute('data-media-type')) {
        case 'model':
          this.viewInSpaceElement.setAttribute('data-shopify-model3d-id', selectedSlide.getAttribute('data-media-id'));
          selectedSlide.firstElementChild.play();
          break;
        case 'external_video':
        case 'video':
          if (this.hasAttribute('autoplay-video')) {
            selectedSlide.firstElementChild.play();
          }
          break;
      }
    }
  };
  window.customElements.define('product-media', ProductMedia);
}
